import React from 'react';
import RatingScale from '../common/RatingScale';
import TextArea from '../common/TextArea';

const NPSPage = ({ 
  npsScore,
  setNpsScore,
  npsFeedback,
  setNpsFeedback,
  handlePrevious,
  handleNext
}) => {
  return (
    <>
      <div className="questions-grid">
        <div className="question-item full-width">
          <label>How likely are you to recommend Cloudphysician's services to other hospitals? </label>
          <RatingScale value={npsScore} onChange={setNpsScore} />
          <p className="rating-description">
            0 = Not at all satisfied, 10 = Extremely satisfied
          </p>
        </div>
        <div className="question-item full-width">
          <label>What are the reasons for your score above?</label>
          <TextArea
            value={npsFeedback}
            onChange={setNpsFeedback}
            placeholder="Please provide your feedback here..."
          />
        </div>
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button" 
          onClick={handleNext}
          disabled={npsScore === null || !npsFeedback.trim()}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default NPSPage;